import { ref } from 'vue'

// Estado compartido entre todos los componentes que usen este composable
const syncingColecciones = ref(false)
const syncColeccionesError = ref(null)
const syncColeccionesResult = ref(null)

export function useColeccionesSync() {
    /**
     * Dispara un re-sync de colecciones en el servidor envivo.
     * El servidor frontendhistorias actúa como proxy para no exponer credenciales al navegador.
     * Es fire-and-forget: no bloquea el flujo del llamador, los errores se loguean en consola.
     */
    async function syncColecciones(serverName) {
        syncingColecciones.value = true
        syncColeccionesError.value = null
        syncColeccionesResult.value = null

        try {
            const response = await fetch(`/api/${serverName}/colecciones/sync`, {
                method: 'POST',
                credentials: 'include',
            })

            const data = await response.json()

            if (!response.ok) {
                throw new Error(data.error || 'Error al sincronizar con envivo')
            }

            syncColeccionesResult.value = data
            console.log(`✅ Envivo sync: ${data.synced} colecciones sincronizadas en el servidor ${serverName}`)
        } catch (err) {
            syncColeccionesError.value = err.message
            console.error('Error sincronizando colecciones con envivo:', err)
        } finally {
            syncingColecciones.value = false
        }
    }

    return { syncingColecciones, syncColeccionesError, syncColeccionesResult, syncColecciones }
}